<template>
    <div>
        <div id="overviewHeader">
            <img :src="organizationData.organization_logo_url" height="64" />
            <div class="rightPanel">
                <p class="low active"> {{ organizationData.current_status }}</p>
                <p>Org Type: {{ organizationData.organization_type }}</p>
            </div>
        </div>
        <div class="overviewSection">
            <h2>Organization</h2>
            <div class="overviewContent">
                <p class="overviewContentGroupDetails">Your organization's information and account settings</p>
                <div class="overviewContentGroup">
                    <div class="overviewContentTextWithLabel">
                        <h4>Organization Name</h4>
                        <p>{{ organizationData.organization_name }}</p>
                    </div>
                    <div class="overviewContentTextWithLabel">
                        <h4>Organization Address</h4>
                        <p>{{ organizationData.organization_address }}</p>
                    </div>
                    <div class="overviewContentTextWithLabel">
                        <h4>Address 2</h4>
                        <p>{{ organizationData.organization_address_2 }}</p>
                    </div>
                    <div class="overviewContentTextWithLabel">
                        <h4>City</h4>
                        <p>{{ organizationData.organization_city }}</p>
                    </div>
                </div>
                <div class="overviewContentGroup">
                    <div class="overviewContentTextWithLabel">
                        <h4>State</h4>
                        <p>{{ organizationData.organization_state }}</p>
                    </div>
                    <div class="overviewContentTextWithLabel">
                        <h4>Zip / Postal Code</h4>
                        <p>{{ organizationData.organization_zip }}</p>
                    </div>
                    <div class="overviewContentTextWithLabel">
                        <h4>Phone Number</h4>
                        <p>{{ organizationData.organization_phone }}</p>
                    </div>
                    <div class="overviewContentTextWithLabel">
                        <h4>Email</h4>
                        <p>{{ organizationData.organization_email }}</p>
                    </div>
                </div>
            </div>
        </div>
        <div class="overviewSection">
            <h2>Main Contact</h2>
            <div class="overviewContent">
                <p class="overviewContentGroupDetails">Your organization's Main Point of Contact for Support and
                    Contractual
                    Needs</p>
                <div class="overviewContentGroup">
                    <div class="overviewContentTextWithLabel">
                        <h4>Contact Name</h4>
                        <p>{{ contact.first_name }} {{ contact.last_name }}</p>
                    </div>
                    <div class="overviewContentTextWithLabel">
                        <h4>Contact Phone Number</h4>
                        <p>{{ contact.primary_phone_number }}</p>
                    </div>
                    <div class="overviewContentTextWithLabel">
                        <h4>Contact Email</h4>
                        <p>{{ contact.primary_email_address }}</p>
                    </div>
                    <div class="overviewContentTextWithLabel">
                        <h4>Contact Title</h4>
                        <p>{{ organizationData.organization_owner_title }}</p>
                    </div>
                </div>
                <div class="overviewContentGroup">
                    <div class="overviewContentTextWithLabel"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CTSRepository from '../../../js/CTSRepository';


export default {
    name: "OrganizationOverview",
    props: ['userData', 'organizationData', 'items', "onItemClicked"],
    data() {
        return {
            contact: {
                first_name: " ",
                last_name: " ",
                primary_phone_number: " ",
                primary_email_address: " ",
            }

        }
    },
    watch: {
        organizationData: function (newVal) {
            if (newVal.organization_id != undefined) {
                try {
                    new CTSRepository(this.$props.organizationData).fetchUser(newVal.organization_owner)
                    .then(data => {
                        console.log("User Search Data", data)
                        if (data.data.length > 0) this.contact = data.data[0]
                    })
                } catch (e) {
                    console.log("Error Fetching", e)
                }

            }
        }
    },
    methods: {
    },
    created() {

    }
};
</script>

<style scoped>
#overviewHeader {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 16px;
}

#overviewHeader img {
    position: relative;
    padding: 8px;
    left: 17px;
}

.rightPanel {
    display: flex;
    width: 250px;
    flex-direction: column;
    justify-content: center;
    align-items: end;
    padding: 8px
}

.active {
    color: white;
    padding: 4px;
    width: 75%;
    border-radius: 4px;
}

.overviewSection {
    text-align: left;
}

.overviewSection h2 {
    padding: 0px 8px;
}

.overviewContent {
    display: flex;
    flex-direction: row;
}

.overviewContentGroup {
    display: flex;
    flex-direction: column;
    flex: 2;
    padding: 0px 16px
}

.overviewContentGroupDetails {
    display: flex;
    flex-direction: row;
    flex: 1;
    padding: 0px 16px;
    font-size: small;
}

.overviewContentTextWithLabel {
    width: 100%;
    margin-bottom: 8px;
}

.overviewContentTextWithLabel p {
    width: 100%;
    border: solid black 1px;
    border-radius: 4px;
}
</style>